import { connect } from "react-redux";
import { compose } from "redux";
import YandexMap from "./YandexMap";


export default compose(connect())(YandexMap);



